import { render, staticRenderFns } from "./NewChatComposer.vue?vue&type=template&id=38ad4d41"
import script from "./NewChatComposer.vue?vue&type=script&lang=js"
export * from "./NewChatComposer.vue?vue&type=script&lang=js"
import style0 from "./NewChatComposer.vue?vue&type=style&index=0&id=38ad4d41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports